import type { Entity, TreeEntity } from '../models/entity.model';

/**
 * Converts a list of entities into a tree of TreeEntities with appropriate parent/child relationships.
 * @param entities List of entities
 */
export const buildEntityTree = (entities: Entity[]): Record<string, TreeEntity> => {
  // Create a tree entity from each entity. Tree entities have references to their parents and children
  const treeEntities = entities.map(entity => {
    const treeEntity: TreeEntity = {
      ...entity,
      Children: []
    };

    return treeEntity;
  });

  // Make a map of the entities for easy access
  const treeEntitiesMap: Record<string, TreeEntity> = {};
  treeEntities.forEach(e => (treeEntitiesMap[e.Id] = e));

  // For each entity with a parent id, add the parent reference to it and add the child to the parent's children array
  treeEntities.forEach(entity => {
    if (entity.ParentId) {
      entity.Parent = treeEntitiesMap[entity.ParentId];
      if (entity.Parent) {
        entity.Parent.Children.push(entity);
      }
    }
  });

  // Return the requested entity
  return treeEntitiesMap;
};
